import React, { MouseEvent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import messengerAdsImg from 'assets/feature-svgs/messenger-ads.svg';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useMessengerAdCRUDActions } from '@mm/state/actions/MessengerAdCRUDActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import EmptyPageBacksplash from '../../../../common/EmptyPageBacksplash/EmptyPageBacksplash';
import { StoreState } from '@mm/state/store-interfaces';
import MessengerTableWithAds from './MessengerTableWithAds';
import { ADD_ENTITY_TEXT, CREATE_NEW_ENTITY } from '../../constants/texts';
import { PlusCircleIcon } from '@mm/icons';

type Props = {
  createAd?: (e?: MouseEvent<HTMLButtonElement>) => any;
};

const MessengerAdsTable = ({ createAd }: Props) => {
  const entities = useSelector((state: StoreState) =>
    state.messengerAds.entities.sort((a, b) => {
      // @ts-ignore
      return new Date(b.updatedAt) - new Date(a.updatedAt);
    }),
  );
  const chatbotId = useSelector(activeChatbotIdSelector);
  const messengerAdCRUDActions = useMessengerAdCRUDActions();

  useEffect(() => {
    messengerAdCRUDActions.retrieveAll(chatbotId);
  }, [chatbotId]);

  if (entities && entities.length > 0) {
    return <MessengerTableWithAds messengerAds={entities} />;
  }

  return (
    <EmptyPageBacksplash pageIcon={messengerAdsImg}>
      {CREATE_NEW_ENTITY}

      <PrimaryButton leftIcon={<PlusCircleIcon />} onClick={createAd}>
        {ADD_ENTITY_TEXT}
      </PrimaryButton>
    </EmptyPageBacksplash>
  );
};

export default MessengerAdsTable;
